<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
		<g transform="translate(-256.251 -224)">
			<path class="a" d="M0,0H45V45H0Z" transform="translate(256.251 224)" />
			<path
				d="M33,4.75H25.162a5.6,5.6,0,0,0-10.575,0H6.75A3.761,3.761,0,0,0,3,8.5V34.75A3.761,3.761,0,0,0,6.75,38.5H33a3.761,3.761,0,0,0,3.75-3.75V8.5A3.761,3.761,0,0,0,33,4.75Zm-13.125,0A1.875,1.875,0,1,1,18,6.625,1.881,1.881,0,0,1,19.875,4.75Zm0,7.5a5.625,5.625,0,1,1-5.625,5.625A5.617,5.617,0,0,1,19.875,12.25Zm11.25,22.5H8.625V32.125c0-3.75,7.5-5.812,11.25-5.812s11.25,2.063,11.25,5.813Z"
				transform="translate(258.876 224.875)" />
		</g>
	</svg>
</template>

<script>
	export default {
		name: 'b-icon-assignment-ind',
		components: {},
		computed: {},
		props: {},
	};
</script>

<style scoped lang="scss">
	path.a {
		fill: none;
	}
</style>

<docs>
	IconAssignmentInd

	```js
	<b-icon-assignment-ind />
	```
</docs>